import { DuplicateCheckFieldsType } from '../types/workflow.types'
import { componentNames } from '../utils/constants'

export const DUPLICATE_CHECK_FIELDS: DuplicateCheckFieldsType = {
  PATIENT: [
    {
      name: 'first_name',
      label: 'First Name',
      key: 'first_name',
      type: 'text',
    },
    {
      name: 'last_name',
      label: 'Last Name',
      key: 'last_name',
    },
    {
      name: 'date_of_birth',
      label: 'Date of Birth',
      type: componentNames.DATE,
      key: 'date_of_birth',
    },
    {
      name: 'email',
      label: 'Email ID',
      key: 'email',
    },
    {
      name: 'phone_number',
      label: 'Primary Phone',
      isPhone: true,
      key: 'c_patient_phones_c_patients.0.phone_number',
    },
    {
      name: 'address_line_1',
      label: 'Address Line 1',
      key: 'c_patient_addresses_c_patients.0.address_line_1',
    },
    {
      name: 'city',
      label: 'City',
      key: 'c_patient_addresses_c_patients.0.city',
    },
    {
      name: 'state',
      label: 'State',
      key: 'c_patient_addresses_c_patients.0.state',
      type: componentNames.DROPDOWN,
    },
    {
      name: 'zip_code',
      label: 'Zip Code',
      key: 'c_patient_addresses_c_patients.0.zip_code',
    },
  ],
  FACILITY: [
    {
      name: 'facility_name',
      label: 'Facility Name',
      key: 'name',
    },
    {
      name: 'facility_npi',
      label: 'Facility NPI',
      key: 'npi',
    },
    {
      name: 'facility_address_1',
      label: 'Facility Address 1',
      key: 'address_line_1',
    },
    {
      name: 'facility_address_2',
      label: 'Facility Address 2',
      key: 'address_line_2',
    },
    {
      name: 'facility_zip',
      label: 'Facility Zip',
      key: 'zip',
    },
    {
      name: 'facility_city',
      label: 'Facility City',
      key: 'city',
    },
    {
      name: 'state',
      label: 'Facility State',
      key: 'state',
    },
  ],
  PROVIDER: [
    {
      name: 'first_name',
      label: 'First Name',
      key: 'first_name',
    },
    {
      name: 'last_name',
      label: 'Last Name',
      key: 'last_name',
    },
    {
      name: 'npi',
      label: 'NPI',
      key: 'npi',
    },
  ],
}
